import { teamEmailAddressSchema } from "@redotech/redo-model/email/domain-verification";
import * as z from "zod/v4";

export const getTeamEmailAddresses = {
  name: "getTeamEmailAddresses" as const,
  input: z.object({}),
  output: z.object({
    addresses: z.array(teamEmailAddressSchema),
    defaultFromAddressId: z.string().nullish(),
    defaultReplyToAddressId: z.string().nullish(),
  }),
};
